import { get, post } from "@/shared/utils/fetchApi";

export interface OAuthConsentHydrationResponse {
  id: string;
  client: {
    id: string;
    name: string;
    clientUri?: string | null;
    logoUri?: string | null;
  };
  scopes: string[];
  state?: string | null;
  redirectUri: string;
  organizationId: string | null;
  products: Array<{
    id: string;
    name: string;
    logoUrl?: string | null;
    // A organização de cada workspace (AB#84509) — a lista pode abranger mais de uma,
    // e é ela que define em qual empresa a autorização é concedida.
    organizationId?: string;
    organizationName?: string;
  }>;
}

// Ambos backends retornam flat (legacy oauth.controller também não envelopa).
export const OAuthFrontendService = {
  getAuthorizationRequest(id: string) {
    return get<OAuthConsentHydrationResponse>(
      `/oauth/authorization-request/${id}`,
    );
  },

  submitConsent(payload: {
    authz_request_id: string;
    organization_id?: string;
    product_id?: string;
    approved: boolean;
  }) {
    return post<{ redirectUrl?: string; redirect_url?: string }>(
      "/oauth/consent",
      payload,
    );
  },
};
